const config = {
  URL: 'https://accounts.circle-lab.com',
};

export default config;
